// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2Bd7L","list":"styles_list__1f9Xs"};